module.exports = __webpack_public_path__ + "img/people.bd80d245.png";